export default __webpack_public_path__ + "static/media/digital-start-gr.e4ef4ba5.svg";